// src/theme.js
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: "'Lexend Deca', sans-serif",
    body: "'Lexend Deca', sans-serif",
  },
  components: {
    Button: {
      baseStyle: {
        _focus: {
          boxShadow: 'none',
          outiline: 'none',
          
        },
      },
    }
  },
});

export default theme;
